import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    question: "What do Collab courses include?",
    answer:
      "Collab courses include a blend of interactive lessons, live sessions, and group projects that encourage teamwork and practical learning. They offer expert guidance from experienced mentors, access to real-world case studies, and hands-on assignments. These courses are designed to enhance both technical skills and collaborative abilities for overall professional growth",
  },
  {
    question: "Do I have to start my course at a certain time?",
    answer:
      "No, you don’t have to start your course at a specific time. Most courses offer flexible start options, allowing you to begin whenever it fits your schedule. This flexibility helps you learn at your own pace and balance your studies with other commitments",
  },
  {
    question: "How do I take a Collab course?",
    answer:
      "You can take a Collab course by enrolling through the platform and selecting the program that matches your interests. Once registered, you’ll get access to interactive lessons, live sessions, and collaborative projects. You can learn online at your own pace while engaging with mentors and peers to enhance your skills and understanding",
  },
  {
    question: "Do I receive anything after I complete a course?",
    answer:
      "Yes, after completing a course, you receive a certificate of completion that recognizes your effort and achievement. This certificate can be added to your resume or portfolio to showcase your skills. It demonstrates your commitment to learning and can help you stand out in academic or professional opportunities.",
  },
  {
    question: "Where can I go for help?",
    answer:
      "If you need help, you can reach out to the course support team or your assigned mentor for guidance. Many platforms also offer discussion forums, chat support, and FAQs to assist you. Whether you need technical help or academic advice, support is always available to ensure a smooth learning experience",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center py-16 px-4 ">
      <h1 className="text-5xl font-bold text-left md:text-center font-barlow text-black mb-12 leading-snug heading">
        Popular Questions to Ask Before <br /> Choosing a Course
      </h1>

      <div className="w-full max-w-6xl space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border-b border-gray-200 py-4 transition-all duration-300"
          >
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="flex justify-between items-center w-full text-left"
            >
              <span className="text-2xl font-bold text-black font-barlow heading">
                {faq.question}
              </span>
              <div className="bg-black text-yellow-400 rounded-full p-2">
                {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
              </div>
            </button>

            {openIndex === index && (
              <p className="mt-3 text-gray-700 transition-all duration-300 sub-heading">
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
